var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaccineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9964 0.789001C13.6174 3.771 9.18143 5.58 4.32043 5.58V18.86C4.32043 25.683 16.9964 31.212 16.9964 31.212C16.9964 31.212 29.6714 25.683 29.6714 18.86V5.58C24.8124 5.58 20.3734 3.771 16.9964 0.789001Z",
    fill: "#00BFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9964 25.127C22.0371 25.127 26.1234 21.0407 26.1234 16C26.1234 10.9593 22.0371 6.87299 16.9964 6.87299C11.9557 6.87299 7.86943 10.9593 7.86943 16C7.86943 21.0407 11.9557 25.127 16.9964 25.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6854 14.311V10.93H15.3064V14.311H11.9264V17.69H15.3064V21.07H18.6854V17.69H22.0664V14.311H18.6854Z",
    fill: "#D9002C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6724 4.791C25.1904 4.791 20.8734 3.16 17.5184 0.198C17.2864 -0.00799957 16.9544 -0.0579996 16.6734 0.0700004C16.5954 0.104 16.5274 0.151 16.4664 0.206C13.1104 3.163 8.79843 4.791 4.32043 4.791C3.88443 4.791 3.53143 5.145 3.53143 5.58V18.86C3.53143 26.116 16.1444 31.7 16.6824 31.934C16.7824 31.979 16.8894 32 16.9964 32C17.1034 32 17.2114 31.979 17.3124 31.935C17.8474 31.701 30.4604 26.117 30.4604 18.861V5.58C30.4614 5.145 30.1074 4.791 29.6724 4.791ZM28.8834 18.86C28.8834 22.041 25.6294 25.006 22.8994 26.935C20.4014 28.701 17.8664 29.939 16.9974 30.344C16.1304 29.941 13.6114 28.71 11.1144 26.948C8.37543 25.016 5.11043 22.046 5.11043 18.859V6.354C9.46343 6.182 13.6344 4.594 16.9964 1.826C20.3574 4.594 24.5294 6.181 28.8824 6.353V18.86H28.8834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08043 16C7.08043 21.468 11.5284 25.916 16.9974 25.916C22.4634 25.916 26.9134 21.468 26.9134 16C26.9134 10.533 22.4644 6.08499 16.9974 6.08499C11.5284 6.08499 7.08043 10.533 7.08043 16ZM25.3344 16C25.3344 20.598 21.5944 24.338 16.9974 24.338C12.3994 24.338 8.65943 20.598 8.65943 16C8.65943 11.403 12.3994 7.66299 16.9974 7.66299C21.5944 7.66299 25.3344 11.403 25.3344 16Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.996429)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccineIcon);
export default __webpack_public_path__ + "static/media/VaccineIcon.c9974d38182f4ae3f60708d9f98d94ef.svg";
export { ForwardRef as ReactComponent };